import { CircularProgress } from '@material-ui/core';
import AuthStore from 'bz-stores/lib/auth-store';
import * as React from 'react';
import { Redirect } from 'react-router';

function Logout() {
  AuthStore.logout();
  if (AuthStore.authenticated) return <CircularProgress />;

  return <Redirect to="/login" />;
}

export { Logout };
